import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { EmployeeVersionDetails } from '../models/EmployeeVersionDetails';
import { VersionModel } from '../models/VersionModel';
import { CrewbidApiService } from './crewbid-api.service';

@Injectable({
  providedIn: 'root',
})
export class VersionManagementService {
  constructor(private ApiService: CrewbidApiService) {}
  /**
   * @method GetAppVersion - Get Latest version of the App
   * @param currentVersion - Current version of the App
   */
  public GetAppVersion(currentVersion): Observable<VersionModel> {
    const param: EmployeeVersionDetails = new EmployeeVersionDetails();
    param.version = currentVersion;
    return this.ApiService.GetRestDataForPost('User/GetAppVersion/', param);
  }
}
